import angular from 'angular';

(function () {
    'use strict';
    angular.module('app.core').factory('LegalEntityGroupUser', LegalEntityGroupUserData);

    LegalEntityGroupUserData.$inject = ['$translate', 'LegalEntityGroup'];

    function LegalEntityGroupUserData($translate, LegalEntityGroup) {
        LegalEntityGroupUser.prototype = {
            build: build,
            buildEmpty: buildEmpty,
            getRoleLabel: getRoleLabel,
            isAdminFo: isAdminFo,
            isWorkflowProfile: isWorkflowProfile,
            isDefaultGroup: isDefaultGroup,
        };

        function LegalEntityGroupUser(LegalEntityGroupUserData) {
            if (LegalEntityGroupUserData) {
                this.build(LegalEntityGroupUserData);
            }
        }

        return LegalEntityGroupUser;

        function buildEmpty() {
            this.id = null;
            this.legalEntityGroup = null;
            this.role = null;
            this.wkfProfile = null;
        }

        function build(legalEntityGroupUserData) {
            this.id = legalEntityGroupUserData.id || null;
            this.legalEntityGroup = new LegalEntityGroup(legalEntityGroupUserData.legalEntityGroup);
            this.role = legalEntityGroupUserData.role;
            this.wkfProfile = legalEntityGroupUserData.wkfProfile || null;
            this.wkfScope = legalEntityGroupUserData.wkfScope || null;
        }

        function getRoleLabel() {
            if (this.role) {
                return $translate.instant('principal.users.roles.' + this.role);
            }
            return '';
        }

        function isAdminFo() {
            return this.role && this.role === 'ADMIN_FO';
        }

        function isWorkflowProfile() {
            return this.role && this.role === 'USER_WKF';
        }

        function isDefaultGroup() {
            return this.legalEntityGroup.isDefaultGroup();
        }
    }
})();
